/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SalesChannel } from './SalesChannel';
import {
    SalesChannelFromJSON,
    SalesChannelFromJSONTyped,
    SalesChannelToJSON,
} from './SalesChannel';
import type { GameBranding } from './GameBranding';
import {
    GameBrandingFromJSON,
    GameBrandingFromJSONTyped,
    GameBrandingToJSON,
} from './GameBranding';
import type { InstantGameType } from './InstantGameType';
import {
    InstantGameTypeFromJSON,
    InstantGameTypeFromJSONTyped,
    InstantGameTypeToJSON,
} from './InstantGameType';

/**
 * Everything a feed sends, plus the presentation fields only the back office writes.
 * @export
 * @interface InstantGame
 */
export interface InstantGame {
    /**
     * Alternative names this game is known by in external systems
     * @type {Array<string>}
     * @memberof InstantGame
     */
    aliases?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof InstantGame
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InstantGame
     */
    activeFrom: Date;
    /**
     * 
     * @type {string}
     * @memberof InstantGame
     */
    gameId: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof InstantGame
     */
    ticketCostOptionsInCents: Array<number>;
    /**
     * 
     * @type {InstantGameType}
     * @memberof InstantGame
     */
    gameType: InstantGameType;
    /**
     * 
     * @type {SalesChannel}
     * @memberof InstantGame
     */
    salesChannel: SalesChannel;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof InstantGame
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof InstantGame
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof InstantGame
     */
    id: string;
    /**
     * Presentation/branding metadata (logo, special ball color)
     * @type {GameBranding}
     * @memberof InstantGame
     */
    branding?: GameBranding | null;
    /**
     * Optional logo image URL for the game
     * @type {string}
     * @memberof InstantGame
     * @deprecated
     */
    logoUrl?: string | null;
}



/**
 * Check if a given object implements the InstantGame interface.
 */
export function instanceOfInstantGame(value: object): value is InstantGame {
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('ticketCostOptionsInCents' in value) || value['ticketCostOptionsInCents'] === undefined) return false;
    if (!('gameType' in value) || value['gameType'] === undefined) return false;
    if (!('salesChannel' in value) || value['salesChannel'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function InstantGameFromJSON(json: any): InstantGame {
    return InstantGameFromJSONTyped(json, false);
}

export function InstantGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstantGame {
    if (json == null) {
        return json;
    }
    return {
        
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': (new Date(json['activeFrom'])),
        'gameId': json['gameId'],
        'ticketCostOptionsInCents': json['ticketCostOptionsInCents'],
        'gameType': InstantGameTypeFromJSON(json['gameType']),
        'salesChannel': SalesChannelFromJSON(json['salesChannel']),
        'customerId': json['customerId'],
        'name': json['name'],
        'id': json['id'],
        'branding': json['branding'] == null ? undefined : GameBrandingFromJSON(json['branding']),
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
    };
}

export function InstantGameToJSON(value?: InstantGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aliases': value['aliases'],
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': ((value['activeFrom']).toISOString()),
        'gameId': value['gameId'],
        'ticketCostOptionsInCents': value['ticketCostOptionsInCents'],
        'gameType': InstantGameTypeToJSON(value['gameType']),
        'salesChannel': SalesChannelToJSON(value['salesChannel']),
        'customerId': value['customerId'],
        'name': value['name'],
        'id': value['id'],
        'branding': GameBrandingToJSON(value['branding']),
        'logoUrl': value['logoUrl'],
    };
}

